<script setup>
import {computed} from 'vue';
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    modelValue: Object | Number,
    disabled: Boolean,
    items: Array,
    titleField: String | undefined,
    valueField: String | undefined,
    emptyTitle: String | undefined,
    hasError: Boolean | undefined,
    defaultItem: {
        type: Boolean,
        default: true
    }
});

const selectItems = computed(() => {
    return props.defaultItem ? [{id: null, [props.titleField ?? 'title']: props.emptyTitle ?? trans('Select')}, ...props.items] : props.items
});

const emit = defineEmits(['update:modelValue']);

const onSelect = (e) => {
    emit('update:modelValue', typeof selectItems.value[e.target.value].id !== 'undefined' ? selectItems.value[e.target.value].id : selectItems.value[e.target.value])
}
const value = computed(() => {
    return selectItems.value.findIndex(item => {
       return item.id === props.modelValue || item.id === props.modelValue?.id;
    })
})
</script>

<template>

    <select
        :disabled="disabled"
        class="border-0 pr-10 max-w-full focus:ring-0 p-0 dark:bg-dark-blue dark:text-slate-200 items-center focus:border-0 text-xl leading-120 font-bold focus:outline-hidden transition ease-in-out truncate"
        @input="onSelect"
        :value="value"
    >
        <option v-for="(item, index) in selectItems" :value="index">
            {{
                titleField ? item[titleField] : item.title
            }}
        </option>
    </select>

</template>
